import { getDetailsEl } from '.';
export const scrollToIndex = (detailsId, elements, elementIdx) => {
    const detailsEl = getDetailsEl(detailsId);
    if (!detailsEl)
        return;
    if (elementIdx < 0) {
        detailsEl.scrollTop = 0;
    }
    else {
        const elementHeight = 48; // 4.8rem
        const visibleHeight = detailsEl.offsetHeight;
        const elementsCount = elements.length;
        const visibleCount = Math.floor(visibleHeight / elementHeight);
        const visibleIdx = Math.floor(visibleCount / 2);
        if (elementIdx <= visibleIdx) {
            detailsEl.scrollTop = 0;
        }
        else {
            detailsEl.scrollTop =
                elementHeight * Math.min(elementIdx - visibleIdx, elementsCount - visibleCount);
        }
    }
};
export const scrollToValue = (detailsId, elements, selectedValue) => {
    const elementIdx = elements.findIndex((child) => String(child.props.value) === selectedValue);
    scrollToIndex(detailsId, elements, elementIdx);
};
//# sourceMappingURL=scrollTo.js.map